
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Profile.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getSidebarMenus } from "../constants/sidebarMenus";
import Button from './ui/Button/Button'
import HeadProfile from "./profile/HeadProfile";
import { Icon } from "@iconify/react";
import TopHeader from "../components/comman/TopHeader";
import Sidebar from "../components/comman/Sidebar";
import { faUser, faEnvelope, faWallet, faCog, faCircleCheck, faStar, faCreditCard, faVideo, faUsers, faBookmark } from "@fortawesome/free-solid-svg-icons";
import Header from "./header/Header";
import { useProfile } from "../hook/useProfile";
import { saveToken, saveUserId, getCurrentUserId, getCurrentUserRole, logout, isLoggedIn, getToken } from "../utils/auth";


function ProfileSettings() {
    const currentUserId = getCurrentUserId();
    // set feed type
    const [feedType, setFeedType] = useState("prime");

    const { isProfileInfo, isLoading, updateProfile } = useProfile();

    const [coverFile, setCoverFile] = useState(null);
    const [image, setImage] = useState(null);

    const handleUpload = async () => {
        if (!image) {
            alert("Please select an image first");
            return;
        }
        const formData = new FormData();
        formData.append("profile_image", image);

    };

    const [preview, setPreview] = useState(null);

    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };
    const handleCoverSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setCoverFile(file);
        setCoverImage(URL.createObjectURL(file));
    };

    const handleCoverUpload = async () => {
        try {
            const formData = new FormData();
            formData.append("cover_image", coverFile);
            alert("Cover image updated successfully");
        } catch (err) {
            alert("Cover upload failed");
        }
    };

    const [activeTab, setActiveTab] = useState("personal");
    const navigate = useNavigate();

    const [activeSidebar, setActiveSidebar] = useState("profile");

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);
    const [showMsgDrawer, setShowMsgDrawer] = useState(false);
    const [showSidebar, setShowSidebar] = useState(true);
    const [showProfile, setShowProfile] = useState(false);
    const profileRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (profileRef.current && !profileRef.current.contains(e.target)) {
                setShowProfile(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleLogout = () => {
        const confirmLogout = window.confirm("Are you sure you want to logout?");

        if (confirmLogout) {
            //clear everything
            // localStorage.clear();

            //Redirect to login page
            navigate("/login");
        }
    };

    const toggleProfileLock = () => {
        setIsProfileLocked(prev => !prev);
    };
    const [isProfileLocked, setIsProfileLocked] = useState(false);

    const openFilePicker = () => {
        fileInputRef.current.click();
    };
    const fileInputRef = useRef(null);
    const handleQuickImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const base64 = await fileToBase64(file);

        setProfileImage(base64);
        localStorage.setItem("profileImage", base64);
    };

    const openCoverPicker = () => {
        coverInputRef.current.click();
    };

    const handleCoverChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const base64 = await fileToBase64(file);

        setCoverImage(base64);
        localStorage.setItem("coverImage", base64);
    };

    const coverInputRef = useRef(null);
    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });

    //   usestate for resfresh
    useEffect(() => {
        const savedProfile = localStorage.getItem("profileImage");
        const savedCover = localStorage.getItem("coverImage");

        if (savedProfile) setProfileImage(savedProfile);
        if (savedCover) setCoverImage(savedCover);
    }, []);

    // initial updated
    const [profileImage, setProfileImage] = useState(
        localStorage.getItem("profileImage") || "/images/profileimg.png"
    );

    const [coverImage, setCoverImage] = useState(
        localStorage.getItem("coverImage") || "/images/Coverpage.jpg"
    );

    // profile imfo 

    const profileInfo = [
        {
            label: "Full Name",
            value: "Helena King",
            type: "text",
            source: "user",
        },
        {
            label: "Email",
            value: "helenakingsrivastava@gmail.com",
            type: "email",
            source: "user",
        },
        {
            label: "Phone Number",
            value: "+91 95468 08606",
            type: "phone",
            source: "user",
        },
        {
            label: "Age",
            value: "20",
            type: "number",
            source: "user",
        },
        {
            label: "Gender",
            value: "Male",
            type: "text",
        },
        {
            label: "Date of Birth",
            value: "5-10-2000",
            type: "date",
            source: "user",
        },
        {
            label: "Bio",
            value: "Food lover exploring new cuisines 🍔🍜",
            type: "text",
            source: "user",
        },
        {
            label: "Country",
            value: "India",
            type: "text",
            source: "default",
        },
        {
            label: "Location",
            value: "Delhi",
            type: "text",
            source: "default",
        },
        {
            label: "Account Type",
            value: "Public",
            type: "text",
            source: "default",
        },
        {
            label: "Joined On",
            value: "Jan 2025",
            type: "date",
            source: "default",
        }
    ];

    const handleFun = () => {
        navigate('/edit-profile')
    }

    const menuItems = [
        { id: "Prime", label: "Prime", icon: faStar, path: "/prime" },
        { id: "Public", label: "Public", icon: faUsers, path: "/public" },
        { id: "Revolution", label: "Revolution", icon: faVideo, path: "/revolution" },
        { id: "wallet", label: "Wallet", icon: faCreditCard, path: "/wallet" },
        { id: "Profile", label: "Verified", icon: faCircleCheck, path: "/verified" },
        { id: "settings", label: "Settings", icon: faCog, path: "/profile" },
    ];

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 967) {
                setShowSidebar(true)
            }
        }

        window.addEventListener("resize", handleResize)
        return () => window.addEventListener("resize", handleResize)

    }, [])

    const handleLogoClick = () => {
        if (window.innerWidth <= 967) {
            setShowSidebar(prev => !prev);
        }
    };

    // Sidebar Menu Error
    const sidebarMenus = getSidebarMenus(currentUserId);


    return (
        <div className="container-xxl p-0">
            <div className="feed-page-wrapper">
                {/* <div className="page-container"> */}

                {/* ================= TOP HEADER NAVBAR ================= */}

                <TopHeader
                    onToggleSidebar={() => setShowSidebar(prev => !prev)}
                    onOpenMessages={() => setShowMsgDrawer(true)}
                    creditAmount={50}
                    notificationCount={5}
                    messageCount={0}
                />

                {/* ================= PRIME PUBLIC LAYOUT CONTAINER ================= */}
                <div className="prime-layout-container .container-fluid">
                    <div className="row">

                        {/* ================= LEFT SIDEBAR ================= */}
                        {/* ===== LEFT SIDEBAR OVERLAY ===== */}
                        {!showSidebar && (
                            <div
                                className="left-sidebar-overlay d-md-none"
                                onClick={() => setShowSidebar(true)}
                            />
                        )}

                        {/* SIDEBAR COMPONENT */}
                        <Sidebar
                            showSidebar={showSidebar}
                            sidebarMenus={sidebarMenus}
                            activeSidebar={activeSidebar}
                            feedType={feedType}
                            onNavigate={(item) => navigate(item.path)}
                            onLogout={handleLogout}
                        />
                        {/* LEFT SIDEBAR END */}

                        {/* ================= CENTER AREA ================= */}
                        <div className="col-md-9 overflow-auto center-area-container" >

                            <div className="center-area">

                                {/* ================= CENTER AREA START ================= */}
                                <div className="w-100 pb-5">

                                    {/* PROFILE START */}
                                    <div className="profile-page">
                                        <HeadProfile MyProfile={isProfileInfo} />

                                        {/*  */}
                                        {/* <div className="profile-content">


                                            <div className="profile-details">

                                                <div className="profile-sidebar">
                                                    <button
                                                        className={`profile-btn ${activeTab === "personal" ? "active" : ""}`}
                                                        onClick={() => setActiveTab("personal")}
                                                    >
                                                        Personal Info
                                                    </button>


                                                    <button
                                                        className={`profile-btn ${activeTab === "password" ? "active" : ""}`}
                                                        onClick={() => setActiveTab("password")}
                                                    >
                                                        Change Password
                                                    </button>
                                                </div>

                                                <div className="personal-info">

                                                    {activeTab === "personal" && (
                                                        <div className="card02">
                                                            <h3 className="card-heading01">Personal Information</h3>

                                                            <div className="info-column">
                                                                {isProfileInfo?.fullName && (
                                                                    <p>
                                                                        <span className="label">Full Name :</span>
                                                                        <span className="value">{isProfileInfo.fullName}</span>
                                                                    </p>
                                                                )}

                                                                {isProfileInfo?.phone && (
                                                                    <p>
                                                                        <span className="label">Phone :</span>
                                                                        <a className="value" href={`tel:${isProfileInfo.phone}`}>
                                                                            {isProfileInfo.phone}
                                                                        </a>
                                                                    </p>
                                                                )}

                                                                {isProfileInfo?.statePublic && (
                                                                    <p>
                                                                        <span className="label">State :</span>
                                                                        <span className="value">{isProfileInfo.statePublic}</span>
                                                                    </p>
                                                                )}

                                                                {isProfileInfo?.districtPublic && (
                                                                    <p>
                                                                        <span className="label">District :</span>
                                                                        <span className="value">{isProfileInfo.districtPublic}</span>
                                                                    </p>
                                                                )}

                                                                {isProfileInfo?.age != null && (
                                                                    <p>
                                                                        <span className="label">Age :</span>
                                                                        <span className="value">{isProfileInfo.age}</span>
                                                                    </p>
                                                                )}

                                                                {isProfileInfo?.role && (
                                                                    <p>
                                                                        <span className="label">Account Role :</span>
                                                                        <span className="value">{isProfileInfo.role}</span>
                                                                    </p>
                                                                )}

                                                                {isProfileInfo?.status && (
                                                                    <p>
                                                                        <span className="label">Profile Status :</span>
                                                                        <span className="value">{isProfileInfo.status}</span>
                                                                    </p>
                                                                )}

                                                                {isProfileInfo?.verifiedUser != null && (
                                                                    <p>
                                                                        <span className="label">Verified User :</span>
                                                                        <span className="value">{isProfileInfo.verifiedUser ? "Yes" : "No"}</span>
                                                                    </p>
                                                                )}

                                                                {isProfileInfo?.createdAt && (
                                                                    <p>
                                                                        <span className="label">Account Created :</span>
                                                                        <span className="value">{new Date(isProfileInfo.createdAt).toLocaleDateString()}</span>
                                                                    </p>
                                                                )}

                                                                <Button onClick={handleFun} className="edit-profile-btn">
                                                                    Edit Profile
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}



                                                    {activeTab === "password" && (
                                                        <div className="card02 password-card">
                                                            <h3>Change Password</h3>

                                                            <input type="password" placeholder="Current Password" />
                                                            <input type="password" placeholder="New Password" />
                                                            <input type="password" placeholder="Confirm Password" />

                                                            <button className="edit-profile-btn">Update Password</button>
                                                        </div>
                                                    )}

                                                    {activeTab === "coverImg" && (
                                                        <div className="card02">
                                                            <h3>Change Cover Image</h3>

                                                            <input type="file" accept="image/*" onChange={handleCoverSelect} />

                                                            <button
                                                                className="edit-profile-btn"
                                                                disabled={!coverFile}
                                                                onClick={handleCoverUpload}
                                                            >
                                                                Upload Cover
                                                            </button>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                        </div> */}
                                        {/*  */}


                                    </div>
                                    {/* PROFILE END */}

                                </div>
                                {/* ================= CENTER AREA END ================= */}

                            </div>
                        </div>

                        {/* ================= RIGHT SIDEBAR ================= */}

                    </div>
                </div>


                {/* Msg Drawer */}
                {
                    showMsgDrawer && (
                        <>
                            <div
                                className="msg-overlay"
                                onClick={() => setShowMsgDrawer(false)}
                            ></div>

                            <div className="msg-drawer">
                                <div className="msg-header">
                                    <h3>Chats</h3>
                                    <span onClick={() => setShowMsgDrawer(false)}>✕</span>
                                </div>

                                <div className="msg-search">
                                    <input placeholder="Search Messenger" />
                                </div>

                                <div className="msg-tabs">
                                    <span className="active">All</span>
                                    <span>Unread</span>
                                    <span>Groups</span>
                                    <span>Communities</span>
                                </div>

                                <div className="msg-empty">
                                    <h4>No chats</h4>
                                    <p>When you have chats, you’ll see them here.</p>
                                </div>

                                <div
                                    className="msg-footer"
                                    onClick={() => {
                                        setShowMsgDrawer(false);
                                        navigate("/message");
                                    }}
                                >
                                    See all in Messenger
                                </div>
                            </div>
                        </>
                    )
                }
                {/* =========== MESSAGE DRAWER END =========== */}

            </div >
        </div>
    );
}
export default ProfileSettings;